import { pdfjs } from 'react-pdf';

// Set up PDF.js worker - use local worker from npm package
// for better performance and offline support
// The worker file is copied from node_modules/pdfjs-dist during build to ensure version matching
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
console.log('PDF.js worker configured (local):', pdfjs.GlobalWorkerOptions.workerSrc);
console.log('PDF.js version:', pdfjs.version);

// Additional PDF.js configuration
pdfjs.GlobalWorkerOptions.workerPort = null;

export default pdfjs;
